import React from "react";

/**
 * Inline icons.
 *
 * Drawn rather than pulled from a font or a package: there are very few of
 * them, they need to inherit `currentColor` so a hover state can recolour them,
 * and a whole icon dependency for this is not a trade worth making.
 *
 * Stroke weight is 1.4 at 16px, which is what the rest of the interface's
 * hairlines read as. Heavier and an icon shouts next to the type it sits with.
 */
const base = {
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.4,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  "aria-hidden": true,
  focusable: false,
};

/**
 * Delete.
 *
 * A cross means "close this" — dismiss the thing in front of you. Destroying a
 * project is a different act and deserves a different sign, or the two read as
 * the same button in different places.
 */
export const TrashIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg {...base} className={className}>
    <path d="M2.9 4.4h10.2" />
    <path d="M6.1 4.4V3.1a.8.8 0 0 1 .8-.8h2.2a.8.8 0 0 1 .8.8v1.3" />
    <path d="M4.2 4.4l.55 8.3a1 1 0 0 0 1 .93h4.5a1 1 0 0 0 1-.93l.55-8.3" />
    <path d="M6.7 6.9v4.2" />
    <path d="M9.3 6.9v4.2" />
  </svg>
);

/** Settings. A gear reads as configuration in every interface anyone has used. */
export const GearIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg {...base} className={className}>
    <circle cx="8" cy="8" r="2.1" />
    <path d="M12.9 9.6a1 1 0 0 0 .2 1.1l.04.04a1.2 1.2 0 1 1-1.7 1.7l-.04-.04a1 1 0 0 0-1.1-.2 1 1 0 0 0-.6.9v.1a1.2 1.2 0 0 1-2.4 0v-.06a1 1 0 0 0-.65-.9 1 1 0 0 0-1.1.2l-.04.04a1.2 1.2 0 1 1-1.7-1.7l.04-.04a1 1 0 0 0 .2-1.1 1 1 0 0 0-.9-.6h-.1a1.2 1.2 0 0 1 0-2.4h.06a1 1 0 0 0 .9-.65 1 1 0 0 0-.2-1.1l-.04-.04a1.2 1.2 0 1 1 1.7-1.7l.04.04a1 1 0 0 0 1.1.2h.05a1 1 0 0 0 .6-.9v-.1a1.2 1.2 0 0 1 2.4 0v.06a1 1 0 0 0 .6.9 1 1 0 0 0 1.1-.2l.04-.04a1.2 1.2 0 1 1 1.7 1.7l-.04.04a1 1 0 0 0-.2 1.1v.05a1 1 0 0 0 .9.6h.1a1.2 1.2 0 0 1 0 2.4h-.06a1 1 0 0 0-.9.6Z" />
  </svg>
);
